export default __webpack_public_path__ + "static/media/heart_pin.550f49f7.svg";